// extracted by mini-css-extract-plugin
module.exports = {"header":"ManualTimeModal_header__1ah-D","content":"ManualTimeModal_content__2E0cN"};